export default "__VITE_ASSET__8f023922__"